import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentTypeChecking: {
        id: 'renewal.directives.templates.bank-account-details.Checking',
        defaultMessage: 'Checking',
    },
    paymentTypeSavings: {
        id: 'renewal.directives.templates.bank-account-details.Savings',
        defaultMessage: 'Savings',
    },
    paymentOptions: {
        id: 'renewal.views.payment-details.Payment Options',
        defaultMessage: 'Payment Options',
    },
    averageMonthlyPremium: {
        id: 'renewal.views.payment-details.Average Monthly Premium',
        defaultMessage: 'Average Monthly Premium:',
    },
    paymentDetails: {
        id: 'renewal.views.payment-details.Payment Details',
        defaultMessage: 'Payment Details',
    },
    totalPremium: {
        id: 'renewal.views.payment-details.Total Premium:',
        defaultMessage: 'Total Premium:',
    },
    paymentBuyNow: {
        id: 'renewal.views.payment-details.submit',
        defaultMessage: 'Submit',
    },
    paymentPlanText: {
        id: 'renewal.views.payment-details.PaymentPlansReadText',
        defaultMessage: 'Please note that depending on the reason for policy cancellation, TWIA may be required by law to keep the full annual premium.'
    },
    additionalMessagePF: {
        id: 'renewal.views.payment-details.AdditionalInterestOtherPrem',
        defaultMessage: 'A Premium Finance Company must be added as an Additional Interest on the <Link>Additional Information</Link> screen.'
    },
    additionalMessageMortgagee:{
        id: 'renewal.views.payment-details.AdditionalInterestMortgagee',
        defaultMessage: 'A Mortgagee must be added as an Additional Interest on the <Link>Additional Information</Link> screen.'
    },
    installmentPopupTitle: {
        id: "renewal.residential.views.installmentsPopupHeader",
        defaultMessage: "Proposed Payment Schedule"
    },
    mortgagee: {
        id: "renewal.residential.views.mortgagee",
        defaultMessage: "Mortgagee"
    },
    pfCompany: {
        id: "renewal.residential.views.pfCompany",
        defaultMessage: "Premium Finance Company"
    },
    pfMessage: {
        id: "renewal.residential.views.pfMessage",
        defaultMessage: "Please refer to your Premium Finance Agreement for all agreement-related details. Finance charges or fees are not included in the amount quoted by TWIA."
    },
    tenPayMsg: {
        id: "renewal.residential.views.tenPayMsg",
        defaultMessage: "This payment plan requires the policyholder to enroll in Auto Pay in the Policyholder Portal. A valid policyholder email address is required for the policyholder to receive enrollment information and billing notifications for this plan. If Auto Pay is not setup, the policy will default to a 4-Pay plan without written notice to you or the policyholder."
    },
    validEmail:{
        id: "renewal.residential.views.validEmail",
        defaultMessage: "A valid policyholder email address is required to select the TWIA 10 Pay (Auto Pay) plan."
    },
    invalidBank: {
        id: 'renewal.views.selfservice.pay.Bad Bank Info Title',
        defaultMessage: 'Invalid Bank Information'
    },
    badBank: {
        id: 'renewal.views.selfservice.pay.badBank',
        defaultMessage: 'The routing or account information is incorrect. Please retype valid information.'
    },
    paymentThreshold: {
        id: "renewal.residential.views.paymentThreshold",
        defaultMessage: "Payment Threshold Exceeded",
    },
    paymentThresholdMsg: {
        id: "renewal.residential.views.paymentThresholdMsg",
        defaultMessage: "Payment amount must be between $3.00 - $99,999.00",
    },
    confirmTransaction: {
        id: "renewal.residential.views.confirmTransaction",
        defaultMessage: "Confirm Transaction",
    },
    confirmTransactionMsg: {
        id: "renewal.residential.views.confirmTransactionMsg",
        defaultMessage: "Do you want to continue?",
    },
    validate10PayEmail: {
        id: "renewal.residential.views.validate10PayEmail",
        defaultMessage: "A valid policyholder email address is required to select the TWIA 10 Pay (Auto Pay) plan.",
    },
    commercialMortgageMessage: {
        id: "renewal.cp.views.commercialMortgageMessage",
        defaultMessage: "A Mortgagee must be added as an Additional Interest within the Building Additional Interest screen."
    },
    commercialPfMessage: {
        id: "renewal.cp.views.commercialPfMessage",
        defaultMessage: "A Premium Finance Company must be added on the <Link>Additional Information</Link> screen in the Premium Finance section."
    },
    uwPolicyHold_twia: {
        id: 'renewal.cp.views.A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.',
        defaultMessage: 'A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.',
    },
    uwOtherBlockingIssue_twia: {
        id: 'renewal.cp.views."Underwriting issues have been raised for this transaction.',
        defaultMessage: 'Underwriting issues have been raised for this transaction.',
    },
    autoPayMessage:{
        id: 'renewal.cp.views.The policyholder is currently setup for Auto Pay. Making any changes to the Payment Details will deactivate Auto Pay',
        defaultMessage: 'The policyholder is currently setup for Auto Pay. Making any changes to the Payment Details will deactivate Auto Pay.',
    },
    autoPayButtonText:{
        id: 'renewal.cp.views.Edit Payment Details',
        defaultMessage: 'Edit Payment Details',
    },
    autoPayPopupTitle:{
        id: 'renewal.cp.views.Edit Payment Details?',
        defaultMessage: 'Edit Payment Details?',
    },
    autoPayPopupMessage:{
        id: 'renewal.cp.views.Editing any payment details will deactivate Auto Pay for the policyholder. Are you sure you want to continue?',
        defaultMessage: 'Editing any payment details will deactivate Auto Pay for the policyholder. Are you sure you want to continue?',
    },
    policyholderEmailRequired: {
        id: 'twia.renewal.payment.views.A valid policyholder email address is required',
        defaultMessage: 'A valid policyholder email address is required because the account/policy is registered with the Policyholder Portal.',
    },
    required: {
        id: 'twia.renewal.Payment.This is a required field.',
        defaultMessage: 'This is a required field.',
    },
    emailValidationMessage: {
        id: 'twia.renewal.Payment.Email.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
    paymentThresholdMsgR352: {
        id: "twia.renewal.residential.views.paymentThresholdMsgR352",
        defaultMessage: "Payment amount must be between $3.00 - $500,000.00",
    },
    unableToProcessPayment: {
        id: "twia.renewal.payment.error.We are unable to process your payment at this time. Please contact TWIA Agent Services at (800) 788-8247",
        defaultMessage: "We are unable to process your payment at this time. Please contact TWIA Agent Services at (800) 788-8247",
    },
    producerEmailError: {
        id: 'twia.renewal.Payment.Email.Producer Email Error',
        defaultMessage: 'This must be the applicant/policyholder email address and must not be one registered with your organization.',
    },
});
